import Feature from './node_modules/ol/Feature.js';
import Map from './node_modules/ol/Map.js';
import View from './node_modules/ol/View.js';
import {boundingExtent} from './node_modules/ol/extent.js';
import Point from './node_modules/ol/geom/Point.js';
import TileLayer from './node_modules/ol/layer/Tile.js';
import VectorLayer from './node_modules/ol/layer/Vector.js';
import Cluster from './node_modules/ol/source/Cluster.js';
import OSM from './node_modules/ol/source/OSM.js';
import VectorSource from './node_modules/ol/source/Vector.js';
import CircleStyle from './node_modules/ol/style/Circle.js';
import Fill from './node_modules/ol/style/Fill.js';
import Stroke from './node_modules/ol/style/Stroke.js';
import Style from './node_modules/ol/style/Style.js';
import Text from './node_modules/ol/style/Text.js';
import Overlay from './node_modules/ol/Overlay.js';
import Icon from './node_modules/ol/style/Icon.js';
import {fromLonLat,toLonLat} from './node_modules/ol/proj.js';
import { compose } from 'ol/transform.js';

const defaultIcon = new Icon({
  src: 'images/mm_36_red.png '
});

const selectedIcon = new Icon({
  src: 'images/mm_36_green.png '
});

if (typeof GeoMashupBasqueland_Data !== 'undefined') {
  showmap(GeoMashupBasqueland_Data);
}

function showmap(data) {

  const places = convertObjectToArray(data.places);
  const categories = data.categories;

  function convertObjectToArray(items) {
    var arr = [];
    for (var i in items) {
      arr.push(items[i]);
    }
    return arr;
  }

  function inArray(needle, haystack) {
    for(var i = 0; i < haystack.length; i++) {
        if(haystack[i] == needle) return true;
    }
    return false;
  }

  function getPlaceFromCoordinates(lon, lat) {
    var i;
    for (i = 0; i < places.length; i++) {
      if(places[i].lat == lat && places[i].lng == lon) { 
        return places[i];
      }
    }
  }

  function getPlaceById(ID) {
    var i;
    for (i = 0; i < places.length; i++) {
      if(places[i].ID == ID) { 
        return places[i];
      }
    }
  }  
    
  function formatPopover(GeoCoordinate) {

    var lon = GeoCoordinate[0];
    var lat = GeoCoordinate[1];
    var place = getPlaceFromCoordinates(lon, lat);

    if (place) {
      return `
      <div class="locationinfo post-location-info">
        <button type="button" aria-label="Close" class="close z-3 position-absolute top-0 start-100 translate-middle badge border border-0 bg-transparent px-1 text-decoration-none text-secondary lh-1 fs-4">
          <span aria-hidden="true">&otimes;</span>
        </button>      
        <h2><a title="${place.title}" href="https://basquecountryguide.com/${place.uri}" target="_parent">${place.title}</a></h2>
        <a title="${place.title}" href="https://basquecountryguide.com/${place.uri}" target="_parent"><img alt="${place.title}" width="300" src="${place.img}"></a>
      </div>
      `;
    }

    return `
    <div class="locationinfo post-location-info">
      <button type="button" aria-label="Close" class="close z-3 position-absolute top-0 start-100 translate-middle badge border border-0 bg-transparent px-1 text-decoration-none text-secondary lh-1 fs-4">
        <span aria-hidden="true">&otimes;</span>
      </button>    
      <h2>Unknown</h2>
    </div>
    `;

  }

  function displayCategories() {

    /**
     * Print list of categories over the map
     */
    var options = ''; 
    categories.forEach(function (item) {
      var cat_ID = item.cat_ID;
      var cat_name = item.cat_name;
      options += '<li class="term-' + cat_ID + '"><span class="term"><label for="gm-category-checkbox-' + cat_ID + '"><input id="gm-category-checkbox-' + cat_ID + '" type="checkbox" name="term_checkbox" value="' + cat_ID + '" checked="checked">' + cat_name + '</label></span></li>';
    });
    document.getElementById("categories").innerHTML += '<div class="format-ul"><ul class="gm-legend category"><li><span><label for="gm-category-check-all"><input type="checkbox" id="gm-category-check-all" checked="checked">Check/Uncheck All</label></span></li>' + options + '</ul></div>';

    /**
     * Manage which features are shown based on selected categories
     */
    const categoryBoxes = document.querySelectorAll("input[name=term_checkbox]");
    categoryBoxes.forEach(item => {
      item.addEventListener('click', event => {
        var selectedCategories = [];
        var checkedBoxes = document.querySelectorAll('input[name=term_checkbox]:checked');
        checkedBoxes.forEach(selected => { 
          selectedCategories.push(selected.value);
        });
        redrawFeatures(selectedCategories);
      });
    });
  
    /**
     * Check and uncheck all categories
     */
    var CategorySelectAll = 1;
    document.querySelector("#gm-category-check-all").addEventListener('click', event => {
      if (CategorySelectAll == 0) {
        CategorySelectAll = 1;
        categoryBoxes.forEach(item => { 
          item.checked = true;
        });
        redrawFeatures(1);
      } else {
        CategorySelectAll = 0;
        categoryBoxes.forEach(item => { 
          item.checked = false;
        }); 
        redrawFeatures([]);
      }
    });
    
  }

  function redrawFeatures(selectedCategories) {

    // Close the popover
    closePopover();

    if (selectedCategories instanceof Array) {
      
      var updatedPlaces = [];
      var updatedFeatures = [];
      var seenPlace = [];
  
      // Create new list of visible places
      for (var i = 0; i < places.length; i++) {
        places[i].categories.forEach(itemCategory => {
          if (inArray(itemCategory, selectedCategories)) {
            if (!inArray(places[i].uri, seenPlace)) {
              updatedPlaces.push(places[i]);
              seenPlace.push(places[i].uri);
            }
          }
        });
      }
      
      // Create new list of visible features
      var i;
      for (i = 0; i < updatedPlaces.length; i++) {
        var coordinates = fromLonLat([updatedPlaces[i].lng, updatedPlaces[i].lat]);
        updatedFeatures.push(new Feature(new Point(coordinates)));
      }  

    } else {
      updatedFeatures = features;
    }

    var newSource = new VectorSource({
      features: updatedFeatures,
    });

    layerMarkers.setSource(newSource);

    layerClusters.setSource(
      new Cluster({
        distance: 70,
        minDistance: 50,
        source: newSource,
      })
    );

  }

  function clusterStyle(feature) {
    const size = feature.get('features').length;

    if (size > 1) {
      return [
        new Style({
          image: new CircleStyle({
            radius: 26,
            fill: new Fill({
              color: 'rgba(229, 2, 1, 0.3)',
            })
          }),
        }),
        new Style({
          image: new CircleStyle({
            radius: 20,
            fill: new Fill({
              color: 'rgba(229, 2, 1, 0.7)',
            }),
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: '#fff',
            }),
            stroke: new Stroke({
              color: '#fff',
              width: 1,
            })
          }),
        }),
      ];
    }

    const originalFeature = feature.get('features')[0];
    return new Style({
      geometry: originalFeature.getGeometry(),
      image: defaultIcon,
    });

  }

  function markerStyle(feature) {
    return new Style({
      geometry: feature.getGeometry(),
      image: defaultIcon,
    });
  }

  function selectedMarkerStyle(feature) {
    return new Style({
      geometry: feature.getGeometry(),
      image: selectedIcon,
      zIndex: 200
    });
  }  

  function showPopover(features) {
    
    // Close the popover
    closePopover();

    const feature = features[0];        
    const coordinate = feature.getGeometry().getCoordinates();
    popup.setPosition([
      coordinate[0],
      coordinate[1],
    ]);
    
    var GeoCoordinate = toLonLat(coordinate);
    GeoCoordinate[0] = parseFloat(GeoCoordinate[0]).toFixed(7);
    GeoCoordinate[1] = parseFloat(GeoCoordinate[1]).toFixed(7);

    popover = new bootstrap.Popover(elementPopup, {
      container: elementPopup.parentElement,
      content: formatPopover(GeoCoordinate),
      html: true,
      offset: [0, 20],
      placement: 'top',
      fallbackPlacements: ['top', 'bottom'],
      sanitize: false,
    });

    popover.show();

    const button = document.querySelector(".popover .close");
    button.addEventListener("click", (event) => {
      // Close the popover
      closePopover();
    });

  }

  function closePopover() {
    if (popover) {
      popover.dispose();
      popover = undefined;
    }
  }

  function showPopoverByID(ID) {

    var selectedPlace = getPlaceById(ID);

    if (!selectedPlace)
      return;
    
    features.forEach(feature => {

      var GeoCoordinate = toLonLat( feature.getGeometry().getCoordinates() );
      GeoCoordinate[0] = parseFloat(GeoCoordinate[0]).toFixed(7);   // Longitud
      GeoCoordinate[1] = parseFloat(GeoCoordinate[1]).toFixed(7);   // Latitud

      if (selectedPlace.lng == GeoCoordinate[0] && selectedPlace.lat == GeoCoordinate[1]) {
        feature.setStyle(selectedMarkerStyle);
        return;
      }

    });

  }

  // Create initial list of Features
  const features = [];
  var i;
  for (i = 0; i < places.length; i++) {
    var coordinates = fromLonLat([places[i].lng, places[i].lat]);
    features.push(new Feature(new Point(coordinates)));
  }

  const vectorSource = new VectorSource({
    features: features,
  });

  const clusterSource = new Cluster({
    distance: 70,
    minDistance: 50,
    source: vectorSource,
  });

  const layerClusters = new VectorLayer({
    source: clusterSource,
    maxZoom: 9.99999,
    style: clusterStyle
  });

  const layerMarkers = new VectorLayer({
    source: vectorSource,
    minZoom: 10,
    style: markerStyle
  });  

  const layerRaster = new TileLayer({
    source: new OSM(),
  });

  const mapView = new View({
    center: fromLonLat(defaultLonLat),
    zoom: defaultZoom,
  });

  const map = new Map({
    target: 'map',
    view: mapView,
    layers: [layerRaster, layerClusters, layerMarkers]
  });

  const elementPopup = document.getElementById('popup');
  const popup = new Overlay({
    element: elementPopup,
    stopEvent: false,
  });

  map.addOverlay(popup);

  map.on('moveend', function () {
    const view = map.getView();
    const center = view.getCenter();
  });

  let popover;
  map.on('click', function (event) {
    var clicked = 0;

    layerMarkers.getFeatures(event.pixel).then((clickedFeature) => {
      if (clicked == 0 && clickedFeature.length == 1) {
        clicked = 1;
        showPopover(clickedFeature);
      }
    });

    layerClusters.getFeatures(event.pixel).then((clickedItems) => {
      if (clicked == 0 && clickedItems.length) {
        clicked = 1;
        var clickedFeature = clickedItems[0].get('features');

        // If clicked on a cluster
        if (clickedFeature.length > 1) {
          const extent = boundingExtent( clickedFeature.map((r) => r.getGeometry().getCoordinates()) );
          map.getView().fit(extent, { duration: 1000, padding: [50, 50, 50, 50] });
        }
        // If clicked on a single marker
        else if (clickedFeature.length == 1) {
          showPopover(clickedFeature);
        }
      } 
    });

  });

  // Set mouse cursor
  map.on('pointermove', function (event) {
    const type = map.hasFeatureAtPixel(event.pixel) ? 'pointer' : 'inherit';
    map.getViewport().style.cursor = type;
  });

  // Display categories
  if (typeof show_categories !== 'undefined' && show_categories == '1') {
    displayCategories();
  }

  // Popover specific point by ID
  if (typeof open_object_id !== 'undefined') {
    showPopoverByID(open_object_id);

  }
  
}
